import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'logzy-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {

  @Input()
  type2: boolean = false;
  borderStye: string="dashed";
  borderColor: string="0000004d";
  constructor() { }

  ngOnInit(): void {
    if(this.type2){
      this.borderStye="solid";
      this.borderColor="#d5d5d5";
    }

  }

}
